export default __webpack_public_path__ + "static/media/project_img_2.019008a8.jpeg";